import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Link } from "react-router-dom";
import { FileDown, ExternalLink, ShieldCheck } from "lucide-react";

const STATUS = { pending_client: "Aguardando cliente", client_signed: "Cliente assinou", fully_signed: "Finalizado" };
const COLOR = { pending_client: "#F59E0B", client_signed: "#3B82F6", fully_signed: "#10B981" };

export default function Contracts() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/contracts").then((r) => setItems(r.data)); }, []);
  return (
    <div className="p-10 max-w-[1400px]">
      <div className="mb-8">
        <p className="overline">Central de Documentos</p>
        <h1 className="font-heading text-4xl mt-2">Contratos</h1>
      </div>
      <Card className="border-border shadow-none">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-muted-foreground"><th className="p-4">Contrato</th><th className="p-4">Status</th><th className="p-4">Criado em</th><th></th></tr></thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.contract_id} className="border-t border-border" data-testid={`contract-row-${c.contract_id}`}>
                <td className="p-4 font-medium">{c.title}</td>
                <td className="p-4"><span className="inline-flex items-center text-xs"><span className="status-dot" style={{ background: COLOR[c.status] }} />{STATUS[c.status]}</span>{c.status === "fully_signed" && <ShieldCheck size={12} className="inline ml-2 text-[#D4AF37]" />}</td>
                <td className="p-4 text-xs text-muted-foreground">{c.created_at?.slice(0, 10)}</td>
                <td className="p-4 text-right space-x-3">
                  <Link to={`/c/${c.public_token}`} className="text-xs text-[#C07C88] inline-flex items-center gap-1" data-testid={`view-contract-${c.contract_id}`}><ExternalLink size={12} /> Abrir</Link>
                  <a href={`${process.env.REACT_APP_BACKEND_URL}/api/contracts/${c.contract_id}/pdf`} target="_blank" rel="noreferrer" className="text-xs text-muted-foreground inline-flex items-center gap-1" data-testid={`pdf-contract-${c.contract_id}`}><FileDown size={12} /> PDF</a>
                </td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan={4} className="p-10 text-center text-sm text-muted-foreground">Nenhum contrato ainda. Contratos são gerados automaticamente ao aprovar uma proposta.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
